import jQuery from "jquery";
import { setWidgetProperties } from "./common-methods-type-free";
import swal from "sweetalert";
import { base_url, query_string, pdf_url, fileName } from "./common-vars";

let pdf_flag = false;
let hub_spot = false;
let submit_marketo = false;

export function getQueryString() {
  let query_string: String = "";
  if (window.location.search === "") {
    query_string = window.location.hash
      .replace(window.location.protocol + "//" + window.location.hostname, "")
      .replace(":", "")
      .replace(window.location.port, "")
      .replace(/[#/?]/g, "");
  } else {
    query_string = window.location.search
      .replace(window.location.protocol + "//" + window.location.hostname, "")
      .replace(":", "")
      .replace(window.location.port, "")
      .replace(/[#/?]/g, "");
  }

  let query_parameter_string: Array<String> = query_string.split("&");
  let query_parameter_and_value: Array<String> = [];

  let query_parameter_container: Object;
  query_parameter_container = {};

  for (let i = 0; i < query_parameter_string.length; i++) {
    query_parameter_and_value = [];
    query_parameter_and_value = query_parameter_string[i].split("=");
    if (query_parameter_and_value.length === 2) {
      query_parameter_container[String(query_parameter_and_value[0])] =
        query_parameter_and_value[1];
    }
  }
  return query_parameter_container;
}

export function saveVisualizer(
  user_information,
  visualizer_input_output_values,
  setView,
  script_id,
  region
) {
  var user = {
    first_name: user_information.f_name,
    last_name: user_information.l_name,
    email_address: user_information.email,
    title: user_information.title,
    company: user_information.company,
  };

  let form_values = Object.assign(
    {},
    visualizer_input_output_values.inputs,
    visualizer_input_output_values.outputs
  );

  form_values["Visualizer Currency"] = region;

  var records = [
    {
      fields: {
        "Visualizer Name":
          user_information.f_name + " " + user_information.l_name,
        "Visualizer Description": user_information.email,
        "Scenario Name": "",
        "Scenario Description": "",
      },
      variables: form_values,
    },
  ];

  jQuery.ajax({
    url: base_url + "/vr/api/visualizer/calculate/id/" + script_id,
    dataType: "jsonp", //Use jsonp to enable cross domain scripting
    data: {
      persist: true,
      user: JSON.stringify(user),
      records: JSON.stringify(records),
    },
    success: function (data, textStatus, jqXHR) {
      console.log({ data });
      console.log({ visualizer_input_output_values });

      var app_update = {
        inputs: visualizer_input_output_values.inputs,
        Visualizer_Name:
          user_information.f_name + " " + user_information.l_name,
        Visualizer_Description: user_information.company,
        outputs: visualizer_input_output_values.outputs,
      };

      // Scope Start - Update Data API
      jQuery.ajax({
        url: base_url + "/vr/api/visualizer/updatedata/id/" + data.createdShare,
        dataType: "json",
        type: "POST", //send it through get method
        data: JSON.stringify(app_update),
        success: function (e, t, i) {
          console.log(pdf_url + "" + data.createdShare);

          let full_pdf_url = pdf_url + "" + data.createdShare;

          marketo(
            user_information,
            full_pdf_url,
            visualizer_input_output_values
          );
          requestPPT(data.createdShare);

          setTimeout(function () {
            checkSubmission(setView);
          }, 1000);
        },
        error: function (e, t, i) {
          console.log("we are in error update");
        },
      });
    },
    error: function (jqXHR, textStatus, errorThrown) {},
  });
}

function submit_hubspot(user_information, full_pdf_url) {
  let portalId = "7651234";
  let formGuid = "2bef9806-dfaa-403b-8ca2-449d53c43308";

  let hubspot_visualizer_data: any = { fields: [] };

  hubspot_visualizer_data.fields.push({
    name: "firstname",
    value: user_information.f_name,
  });

  hubspot_visualizer_data.fields.push({
    name: "lastname",
    value: user_information.l_name,
  });

  hubspot_visualizer_data.fields.push({
    name: "email",
    value: user_information.email,
  });

  hubspot_visualizer_data.fields.push({
    name: "phone",
    value: user_information.phone,
  });

  hubspot_visualizer_data.fields.push({
    name: "company",
    value: user_information.company,
  });

  hubspot_visualizer_data.fields.push({
    name: "country_ok",
    value: user_information.country,
  });

  hubspot_visualizer_data.fields.push({
    name: "job_function",
    value: user_information.job,
  });

  hubspot_visualizer_data.fields.push({
    name: "seniority",
    value: user_information.seniority,
  });

  hubspot_visualizer_data.fields.push({
    name: "business_unit",
    value: "Slimstock US",
  });

  hubspot_visualizer_data.fields.push({
    name: "form___testimonials_benchmark_ebook__looking_for_evidence_",
    value: true,
  });

  hubspot_visualizer_data.fields.push({
    name: "us___lead_harvester_report_url",
    value: full_pdf_url,
  });

  hubspot_visualizer_data.fields.push({
    name: "type_of_form",
    value: " Benchmark/ebook",
  });

  hubspot_visualizer_data.fields.push({
    name: "LEGAL_CONSENT.subscription_type_9819977",
    value: true,
  });

  jQuery.ajax({
    url:
      "https://api.hsforms.com/submissions/v3/integration/submit/" +
      portalId +
      "/" +
      formGuid,
    contentType: "application/json",
    dataType: "json",
    async: false,
    data: JSON.stringify(hubspot_visualizer_data),
    method: "POST",
    success: function (data, textStatus, jqXHR) {
      console.log("hubsport submitted successfully");
      hub_spot = true;
    },
    error: function (jqXHR, textStatus, errorThrown) {},
  });
}

function marketo(
  user_information,
  full_pdf_url,
  visualizer_input_output_values
) {
  jQuery("#FirstName").val(user_information.f_name);
  jQuery("#LastName").val(user_information.l_name);
  jQuery("#Email").val(user_information.email);
  jQuery("#Company").val(user_information.company);
  jQuery("#Phone").val(user_information.phone);

  let qs = getQueryString();
  jQuery("[name=pDFUrl]").val(full_pdf_url);
  jQuery("#utm_campaign__c").val(
    qs["utm_campaign__c"] ? qs["utm_campaign__c"] : "utm_campaign__c"
  );
  jQuery("#utm_content__c").val(
    qs["utm_content__c"] ? qs["utm_content__c"] : "utm_content__c"
  );
  jQuery("#utm_medium__c_lead").val(
    qs["utm_medium__c_lead"] ? qs["utm_medium__c_lead"] : "utm_medium__c_lead"
  );
  jQuery("#utm_source__c_lead").val(
    qs["utm_source__c_lead"] ? qs["utm_source__c_lead"] : "utm_source__c_lead"
  );
  jQuery("#utm_term__c").val(
    qs["utm_term__c"] ? qs["utm_term__c"] : "utm_term__c"
  );

  jQuery(".mktoButton").click();
  console.log("clicked");
}

jQuery(() => {
  let window_copy: any = window;

  let formId = "1721";
  let munchkinId = "597-VSX-966";
  let marketo_url = "//go.diamanti.com";

  jQuery("body").append(
    `<form id="mktoForm_` + formId + `" class="hidden"></form>`
  );

  window_copy.MktoForms2.loadForm(
    marketo_url,
    munchkinId,
    formId,
    function (form) {
      form.onSuccess(function (vals, thanksURL) {
        submit_marketo = true;
        return false;
      });
    }
  );

  // jQuery("#mktoForm_2062").onsubmit = function (e) {
  //   alert("testing 2");
  //   e.preventDefault();
  // };

  // jQuery(".mktoButton").submit(function (e) {
  //   alert(" prevent reloading!");
  //   e.preventDefault();
  //   return false;
  // });
});

function checkSubmission(setView) {
  console.log("we are in checkSubmission");
  if (pdf_flag == true && submit_marketo == true) {
    setView("");
  } else {
    setTimeout(function () {
      checkSubmission(setView);
    }, 3000);
  }
}

function requestPPT(id) {
  var file_id = Math.floor(Math.random() * (10000000000 - 1 + 1) + 1);

  jQuery.ajax({
    type: "GET",
    timeout: 10000,
    url:
      base_url +
      "/vr/api/visualizer/downloadexport/id/" +
      id +
      "/fileType/PDF/fileName/" +
      fileName +
      "?file_id=" +
      file_id,
    success: function () {
      doPoll(file_id);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if (textStatus === "timeout") {
        doPoll(file_id);
      } else {
        pdf_flag = true;
      }
    },
  });
  return false;
}

function doPoll(id) {
  jQuery.ajax({
    type: "GET",
    url: base_url + "/vr/api/visualizer/CheckPdfPoll/file_id/" + id,
    error: function (request, textStatus, errorThrown) {
      var millisecondsToWait = 10000;
      setTimeout(() => {
        doPoll(id);
      }, millisecondsToWait);
    },
    success: function (result) {
      if (result.status == "success") {
        var URL_PDF =
          base_url +
          "/vr/api/visualizer/CheckPdfPoll/file_id/" +
          id +
          "?stream=1&fileName=" +
          fileName;
        jQuery("#iframe-div").append(
          '<iframe src="' + URL_PDF + '" style="display:none;"></iframe>'
        );
        pdf_flag = true;
        return false;
      } else if (result.status == "again") {
        var millisecondsToWait = 10000;
        setTimeout(() => {
          doPoll(id);
        }, millisecondsToWait);
      } else {
      }
    },
    dataType: "json",
    timeout: 10000,
  });
  return false;
}

function emailSending(user_data) {
  jQuery.ajax({
    method: "POST",
    url: "ajax_responder.php",
    async: false,
    dataType: "text",
    //All request parameters are optional
    data: user_data,
    success: function (data, textStatus, jqXHR) {
      //email_sending = true;
      console.log(" email sended");
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log("error email sending");
    },
  });
}

export function loadWidgetData(url, call_back) {
  jQuery.getScript(url, function () {
    setWidgetProperties();
    call_back();
  });
}

function reloadApplication(hubspot, pardot, marketo) {
  return;
  if (hubspot === true && pardot === true && marketo === true) {
    window.location.reload();
  }
}

export const validateForm = (user_info) => {
  let error: any = [];

  if (user_info.checkbox == false) {
    error.push("checkbox");
  }

  if (
    user_info.email == "" ||
    !requireBusinessEmail(user_info.email) ||
    !validateEmail(user_info.email)
  ) {
    error.push("email");
  }

  Object.keys(user_info).forEach((key) => {
    if (key == "checkbox") {
    } else if (user_info[key] == "") {
      error.push(key);
    }
  });

  return error;
};

function validateEmail(email: string) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test(email);
}

function requireBusinessEmail(emailVal: string) {
  var hasPersonalEmail;
  personalEmailDomains.forEach(function (domain) {
    if (emailVal.indexOf("@" + domain.toLowerCase()) !== -1) {
      hasPersonalEmail = true;
    }
  });

  if (hasPersonalEmail == true) {
    return false;
  } else {
    return true;
  }
}

const personalEmailDomains = [
  "Akkadianlabs.com",
  "Kurmi-software.com",
  "theBlackChair.com",
  "Unimax.com",
  "Voss-solutions.com",
  "AOL.com",
  "Gmail.com",
  "iCloud.com",
  "Protonmail.com",
  "Yahoo.com",
  "yahoomail.com",
  "Zoho.com",
  "abc.com",
  "abc.co",
  "xyz.com",
  "xyz.co",
];

export function iconClick() {
  jQuery("#cf").animate({
    opacity: "0.5",
  });
  setTimeout(function () {
    window.open("https://valuecore.ai", "_blank");
    jQuery("#cf").animate({
      opacity: "1",
    });
  }, 500);
}
